<template>
  <tr class="smartcard-row">
    <td>
      {{ smartcard.cardNumber }} <em class="red" v-if="smartcard.deletedAt">(Deleted)</em>
    </td>
    <td>
      {{ smartcard.chipId }}
    </td>
    <td>
      <router-link v-if="smartcard.Account" :to="{ path: `/membership/members/${smartcard.Account.uuid}` }">
        {{ smartcard.Account.dropdownLabel }}
      </router-link>
      <em v-else>Unassigned</em>
    </td>
    <td>
      {{ smartcard.note }}
    </td>
    <td>
      <dropdown-input
        :is-small="true"
        label="Actions"
        label-icon="fa-id-card"
        :dropup="true"
        :actions="smartcardActions(smartcard, null)"
        @action="executeAction($event, smartcard)">
      </dropdown-input>
    </td>
  </tr>
</template>

<script>
import DropdownInput from '@/components/inputs/DropdownInput'
import { mapGetters, mapActions } from 'vuex'
import {
  DELETE_SMARTCARD,
  RESTORE_SMARTCARD,
  ASSIGN_SMARTCARD,
  UNASSIGN_SMARTCARD
} from '@/vuex/types'
export default {
  name: 'SmartcardRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  components: {
    DropdownInput
  },
  computed: {
    smartcard () {
      return {
        Account: {
          dropdownLabel: ''
        },
        ...this.object
      }
    },
    ...mapGetters([
      'smartcardActions'
    ])
  },
  methods: {
    async executeAction (action, payload) {
      let result = await this[action](payload)
      if (result && result.updated) this.updatedAccount = result.updated
    },
    ...mapActions([
      DELETE_SMARTCARD,
      RESTORE_SMARTCARD,
      ASSIGN_SMARTCARD,
      UNASSIGN_SMARTCARD
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/Smartcard.vue